import { createTheme } from "@material-ui/core/styles";
import styles from "../styles/variables.scss";

export const DialogTheme = createTheme({
    overrides: {
        MuiDialog: {
            paperWidthSm: {
                width: "50%",
                maxWidth: "600px",
                minHeight: "200px",
                maxHeight: "90%",
                background: styles.backgroundColor,
                overflow: "visible !important",
                fontFamily: "Montserrat, sans-serif !important",
                borderRadius: `24px`
            },
            paper: {
                borderRadius: `4px`
            }
        },
        MuiDialogTitle: {
            root: {
                background: styles.backgroundColor,
                color: styles.fontColor,
                padding: `${styles.defaultPadding} ${styles.defaultPadding} ${styles.defaultPadding} 0`,
                borderBottom: `1px solid ${styles.thirdBackgroundColor}`,
                margin: `0 ${styles.defaultPadding}`,
                marginBottom: "8px",
            }
        },
        MuiDialogContent: {
            root: {
                background: styles.backgroundColor,
                color: styles.secondFontColor,
                padding: `5px ${styles.defaultPadding} 5px ${styles.defaultPadding}`,
                "&::-webkit-scrollbar": {
                    display: "none"
                },
                overflow: "visible !important"
            }
        },
        MuiDialogActions: {
            root: {
                background: styles.backgroundColor,
                color: styles.fontColor,
                padding: styles.defaultPadding,
                borderRadius: `24px`
            }
        },
        MuiButton: {
            root: {
                color: "inherit",
                borderRadius: styles.borderRadiusCard
            }
        }
    }
});

export const DialogThemeForm = createTheme({
    overrides: {
        MuiDialog: {
            paperWidthSm: {
                width: "85%",
                "max-width": "850px",
                "max-height": "90%",
                "min-height": "200px",
                overflow: "visible !important",
                background: styles.backgroundColor,
                fontFamily: "Montserrat, sans-serif !important"
            },
            paper: {
                borderRadius: `4px`
            }
        },
        MuiDialogTitle: {
            root: {
                background: styles.backgroundColor,
                color: styles.fontColor,
                padding: `${styles.defaultPadding} ${styles.defaultPadding} ${styles.defaultPadding} 0`,
                borderBottom: `1px solid ${styles.thirdBackgroundColor}`,
                margin: `0 ${styles.defaultPadding}`
            }
        },
        MuiDialogContent: {
            root: {
                background: styles.backgroundColor,
                color: styles.secondFontColor,
                padding: `${styles.defaultPadding} ${styles.defaultPadding} 0 ${styles.defaultPadding}`,
                "&::-webkit-scrollbar": {
                    display: "none"
                },
                overflow: "visible !important"
            }
        },
        MuiDialogActions: {
            root: {
                background: styles.backgroundColor,
                color: styles.fontColor,
                padding: styles.defaultPadding
            }
        },
        MuiButton: {
            root: {
                color: "inherit",
                borderRadius: styles.backgroundColor
            }
        }
    }
});

export const DialogThemeFormOverflow = createTheme({
    overrides: {
        MuiDialog: {
            paperWidthSm: {
                width: "85%",
                "max-width": "850px",
                "max-height": "90%",
                "min-height": "200px",
                background: styles.backgroundColor,
                fontFamily: "Montserrat, sans-serif !important"
            },
            paper: {
                borderRadius: `4px`
            }
        },
        MuiDialogTitle: {
            root: {
                background: styles.backgroundColor,
                color: styles.fontColor,
                padding: `${styles.defaultPadding} ${styles.defaultPadding} ${styles.defaultPadding} 0`,
                borderBottom: `1px solid ${styles.thirdBackgroundColor}`,
                margin: `0 ${styles.defaultPadding}`,
                "& > * ": {
                    display: "flex",
                    "justify-content": "space-between",
                    "alignItems": "center"
                },
                "font-family": "'Montserrat', sans-serif"
            }
        },
        MuiDialogContent: {
            root: {
                background: styles.backgroundColor,
                color: styles.secondFontColor,
                padding: `${styles.defaultPadding} ${styles.defaultPadding} 0 ${styles.defaultPadding}`,
                "&::-webkit-scrollbar": {
                    display: "none"
                },
                "font-family": "'Montserrat', sans-serif"
            }
        },
        MuiDialogActions: {
            root: {
                background: styles.backgroundColor,
                color: styles.fontColor,
                padding: styles.defaultPadding
            }
        },
        MuiButton: {
            root: {
                color: "inherit",
                borderRadius: styles.backgroundColor
            }
        }
    }
});